<template>
  <div>
    <form>
      <p v-show="replaceNow">{{ $t('record_show.move_data.title') }}</p>
      <p v-show="!replaceNow">{{ $t('record_show.move_data.title_future') }}</p>
      <label class="checkbox-container" v-if="replaceNow">
        {{ $t('record_show.move_data.save_options') }}
        <input type="checkbox" v-model="versionOptionsSave" @change="changeAction">
        <span class="checkmark" data-toggle="tooltip" title=""></span>
      </label>

      <p>{{ $t('record_show.move_data.options_label') }}</p>
      <label class="checkbox-container">
        {{ $t('record_show.move_data.notes') }}
        <input type="checkbox" name="version_options[]" v-model="versionOptions" value="notes" @change="changeAction">
        <span class="checkmark" data-toggle="tooltip" title=""></span>
      </label>
      <label class="checkbox-container">
        {{ $t('record_show.move_data.expiration_info') }}
        <input type="checkbox" name="version_options[]" v-model="versionOptions" value="expiration_dates" @change="changeAction">
        <span class="checkmark" data-toggle="tooltip" title=""></span>
      </label>
      <label class="checkbox-container">
        {{ $t('record_show.move_data.tags') }}
        <input type="checkbox" name="version_options[]" v-model="versionOptions" value="tags" @change="changeAction">
        <span class="checkmark" data-toggle="tooltip" title=""></span>
      </label>
<!--      <label class="checkbox-container">-->
<!--        {{ $t('record_show.move_data.checklist_connections') }}-->
<!--        <input type="checkbox" name="version_options[]" v-model="versionOptions" value="checklists" @change="changeAction">-->
<!--        <span class="checkmark" data-toggle="tooltip" title=""></span>-->
<!--      </label>-->
      <label class="checkbox-container">
        {{ $t('record_show.move_data.do_nothing') }}
        <input type="checkbox" name="versionOptionsDoNothing" v-model="versionOptionsDoNothing"
               v-on:input="doNothingOption" />
        <span class="checkmark" data-toggle="tooltip" title=""></span>
      </label>
    </form>
  </div>
</template>

<script>
  export default {
    props: {
      userVersionOptions: {
        required: true,
        default: () => (["checklists"])
      },
      replaceNow:{
        required: false,
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        versionOptions: this.$props.userVersionOptions || (["checklists"]),
        versionOptionsSave: true,
        versionOptionsDoNothing: (this.$props.userVersionOptions.includes("checklists") && this.$props.userVersionOptions.length === 1)
      }
    },
    methods: {
      changeAction(){
        // Fix checklists always enable
        this.versionOptionsDoNothing = (this.versionOptions.includes("checklists") && this.versionOptions.length === 1 || false)
        this.$emit('version-options-callback', this.versionOptions, this.versionOptionsSave, false)
      },
      doNothingOption(){
        this.versionOptionsDoNothing = !this.versionOptionsDoNothing
        this.versionOptions = ((this.versionOptionsDoNothing) ? (["checklists"]) : this.$props.userVersionOptions)
        this.changeAction()
      }
    }
  }
</script>
